import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_toast.scss'

import { Props, DivAttributes } from '../utils/types'

export namespace ToastVariantNS {
  export const error = 'error'
  export const success = 'success'
}

type ToastVariant = typeof ToastVariantNS.error | typeof ToastVariantNS.success

interface ToastProps extends Props {
  variant: ToastVariant
}

const cx = bind(styles)

const Toast = React.forwardRef<HTMLDivElement, DivAttributes & ToastProps>(
  ({ children, className, variant, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(className, 'core-toast', `core-toast--${variant}`)}
      {...props}
    >
      <span className={cx('core-toast__icon')}>
        <span
          className={cx('ci', {
            'ci-error-o': variant === ToastVariantNS.error,
            'ci-success-circle-o': variant === ToastVariantNS.success,
          })}
        />
      </span>
      <span className={cx('core-toast__label')}>{children}</span>
    </div>
  )
)

Toast.displayName = 'Toast'

export default Toast
